import React from 'react';
import { useTranslation } from 'react-i18next';
import { Screen } from '@/components/layout/Screen';

export const AnalyticsScreen: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Screen
      showTopBar
      showBottomNav
      topBarProps={{ title: t('analytics.title'), showBack: false }}
    >
      <div className="flex flex-col items-center justify-center h-[60vh] text-center p-6">
        <span className="text-6xl mb-4">📊</span>
        <h2 className="text-xl font-semibold text-foreground">{t("analytics.comingSoon", { defaultValue: "Analytics Coming Soon" })}</h2>
        <p className="text-sm text-muted-foreground mt-2">{t("analytics.comingSoonDesc", { defaultValue: "Detailed performance insights will appear here in a future update." })}</p>
      </div>
    </Screen>
  );
};
